// Решение staff-гейта для маршрутов с meta.requiresStaff — вынесено из
// router/index.js отдельным модулем, чтобы его можно было проверить
// поведенчески.
//
// Почему не тестировать сам guard, импортировав "@/router". Технически это
// возможно (NormalModuleReplacementPlugin подменяет стабом только
// ОТНОСИТЕЛЬНЫЕ импорты, /^(\.\.?\/)+router$/, так что алиас отдаёт реальный
// модуль), и такой спек проходит сам по себе. Но импорт роутера выполняет
// Vue.use(Router) в общем тест-бандле, а vue-router определяет $route/$router
// на Vue.prototype через Object.defineProperty без setter'а. После этого
// vue-test-utils больше не может подменить их через mocks — «could not
// overwrite property $route» — и в полном прогоне падают 14 чужих спеков
// (BookingsBoard, NotificationsPage, PeriodsEditor и др.). Проверено: сюит
// шёл 1404 passing / 14 failing ровно из-за этого импорта.
import { STAFF_ROLES } from "@/constants/roles";

// Возвращает аргумент для next() — либо undefined, если роль пропускаем.
//
// Именно allowlist, а не «не guest и не partner»: роль agent завели позже
// остальных, и отрицания пропускали её молча — инцидент 12.08.2026, ~274
// проверки (см. src/constants/roles.js). При allowlist новая не-staff роль
// бэкенда упрётся здесь сама.
//
// Пустая роль — не отказ. Гидрация vuex-persist синхронна, так что роль
// известна во всех живых сценариях, но сохранённого блока может не оказаться
// при живом auth_token, а выбросить сотрудника на Home из-за этого хуже, чем
// пустить его дальше. Дыру от этого fail-open закрывает гейт в
// TasksBoard.created() (симметрично TaskList): неизвестная роль доходит до
// экрана, но в сеть не идёт. Гейт здесь — UX, защита за ensure_staff!.
export function staffGateRedirect(role) {
  if (role && !STAFF_ROLES.includes(role)) {
    return { name: "Home", query: { error: "staff_only" } };
  }
  return undefined;
}
